import Module from '../module';
// import gsap from 'gsap';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import scroll from '../../libs/scroll/scroll';

import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../libs/slider/slider-list-cut';
import container from '../../libs/container/container';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeProjectsMediaCarouselNavItemInnerCls: string;
			homeProjectsMediaCarouselNavItemStarCls: string;
			homeProjectsMediaCarouselArrowLeftId: string;
			homeProjectsMediaCarouselArrowRightId: string;
			homeProjectsMediaCarouselPagerWrapperId: string;
			homeProjectsMediaCarouselListId: string;
		}
	},

	sliderListCutSetup?: SliderListCutSetupInterface

	slug: string
}

class Projects extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Projects Module');

		this.publicVars = options;

		// gsap.registerPlugin(ScrollTrigger);
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.sliderListCutSetup) {
			this.errorMsg('sliderSetup is not defined');
		} else {
			const slider = sliderListCutFactory.create();
			slider.init(this.publicVars.sliderListCutSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemInnerCls + '1', 'home_projects', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemInnerCls + '2', 'home_projects', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemInnerCls + '3', 'home_projects', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemInnerCls + '4', 'home_projects', { animCls: 'animate__zoomIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemStarCls + '1', 'home_projects', { animCls: 'animate__rotateIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemStarCls + '2', 'home_projects', { animCls: 'animate__rotateIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselNavItemStarCls + '3', 'home_projects', { animCls: 'animate__rotateIn', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselArrowLeftId || '', 'home_projects', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselArrowRightId || '', 'home_projects', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselPagerWrapperId || '', 'home_projects', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeProjectsMediaCarouselListId || '', 'home_projects', { animCls: 'animate__fadeIn', once: true});

	}

	bind() {
		this.msg('bind');

		// gsap.from('.media-carousel__nav-item-star', {
		// 	rotation: 360,
		// 	stagger: 0.1,
		// 	z: 0.01,
		// 	scrollTrigger: {
		// 		trigger: '.media-carousel__nav-item-star',
		// 		toggleActions: "restart none restart none"
		// 	},
		// 	duration: 0.3
		// })
		//
		//
		//
		// let isRegistered = false;
		//
		// window.addEventListener('scroll', () => {
		//
		// 	let ticking = false;
		//
		// 	if (!ticking) {
		// 		window.requestAnimationFrame(function () {
		// 			try {
		//
		// 				if(!ScrollTrigger.isInViewport('.media-carousel__nav-item-inner1') && !isRegistered) {
		// 					isRegistered = true;
		// 					document.querySelector('.media-carousel__nav-item-inner1')?.classList.remove('animate__animated', 'animate__zoomIn');
		//
		// 					gsap.from('.media-carousel__nav-item-inner1', {
		// 						// scaleX: 0.3, scaleY: 0.3, scaleZ: 0.3,
		// 						// opacity: 0,
		// 						scrollTrigger: {
		// 							trigger: '.media-carousel__nav-item-inner1',
		// 							toggleActions: "restart none restart none",
		// 							onToggle: ({ isActive }: {isActive: boolean}) => {
		// 								if(isActive) {
		// 									document.querySelector('.media-carousel__nav-item-inner1')?.classList.add('animate__animated', 'animate__zoomIn')
		// 								} else {
		// 									document.querySelector('.media-carousel__nav-item-inner1')?.classList.remove('animate__animated', 'animate__zoomIn')
		// 								}
		// 							},
		// 						},
		// 						duration: 0.6
		// 					})
		// 				}
		//
		// 			} catch(e) {
		//
		// 			}
		// 			ticking = false;
		// 		});
		// 	}
		// 	ticking = true;
		//
		// });


	}
}

export default Projects;